import { TimezoneKey, SUBSCRIBER_LOCAL_TIME } from './constants/scheduling';

export type CampaignStatus =
  | 'draft'
  | 'scheduled'
  | 'sending'
  | 'paused'
  | 'delivered'
  | 'suspended';

export enum CampaignType {
  BLAST = 'blast',
  SPLIT_SEND = 'split_send',
  UNSPECIFIED = 'unspecified'
}

export type CampaignChannel = 'sms' | 'email' | 'push';

export type ScheduleType = 'draft' | 'now' | 'schedule';
export type TimezoneType = 'local' | 'universal';

export type PastTimezoneBehavior = 'send_immediately' | 'send_next_day' | 'skip';
export type UnknownTimezoneBehavior = 'use_fallback' | 'skip';

export interface LocalTimeConfig {
  date: string;
  time: string;
  pastTimezoneBehavior: PastTimezoneBehavior;
  unknownTimezoneBehavior: UnknownTimezoneBehavior;
  fallbackTimezone: Exclude<TimezoneKey, typeof SUBSCRIBER_LOCAL_TIME>;
}

export interface UniversalTimeConfig {
  date: string;
  time: string;
  timezone: Exclude<TimezoneKey, typeof SUBSCRIBER_LOCAL_TIME>;
}

export type SchedulingConfig = {
  type: TimezoneType;
  config: LocalTimeConfig | UniversalTimeConfig;
};

export interface CampaignScheduling {
  type: ScheduleType;
  config?: SchedulingConfig;
}

export interface Campaign {
  campaignId: string;
  name: string;
  type: CampaignType;
  channels: CampaignChannel[];
  createdAt?: string;
  scheduled?: CampaignScheduling;
  generatedAt?: string;
  merchantId: string;
  segments: {
    include: string[];
    exclude: string[];
  };
  status: CampaignStatus;
  metrics: {
    opened: number;
    sent: number;
    clicked: number;
    ordered: number;
    earned: number;
  };
}
